@if (state() === "loading") {
  <app-loading />
}

@if (state() === "error") {
  <app-error-data
    [title]="isArabic() ? 'حدث خطأ ما' : 'Something went wrong'"
    [showRetry]="true"
    (retry)="retry.emit()" />
}

@if (state() === "success") {
  <app-tables
    [headerItems]="tableHeaderData()"
    [rows]="rows()"
    (toggleDropdown)="toggleDropdown($event)"
    [currentActions]="currentActions()"
    (actionTrigger)="handleAction($any($event))"
    [isFiltersApplied]="isFiltersApplied()"
    [emptyFilterTitle]="isArabic() ? 'لا توجد نتائج تطابق معايير البحث.' : 'No results match your search criteria.'"
    [emptyContentTitle]="isArabic() ? 'لا توجد عربات' : 'No Carts Found'"
    [emptyContentDescription]="isArabic() ? 'لم يتم إنشاء أي عربات بعد.' : 'No carts have been created yet.'" />

  <app-pagination
    [itemsPerPage]="itemsPerPage()"
    [currentPage]="currentPage()"
    [getPageNumbers]="pageNumbers()"
    [totalPages]="totalPages()"
    [startItem]="startItem()"
    [endItem]="endItem()"
    [totalItems]="totalItems()"
    (previousPage)="onPreviousPage()"
    (nextPage)="onNextPage()"
    (goToPage)="onGoToPage($event)"
    (changePageNumber)="onChangePageNumber($event)"
    (pageSizeChange)="onPageSizeChange()" />

  @if (showCheckoutDialog()) {
    <app-confirmation-dialog
      [layout]="'start'"
      [title]="isArabic() ? 'إتمام الطلب؟' : 'Checkout Cart?'"
      [description]="
        (isArabic() ? 'هل أنت متأكد أنك تريد إتمام الطلب لـ ' : 'Are you sure you want to checkout for ') +
        (selectedCart()?.pharmacy?.nickName ?? '') +
        '?'
      "
      [confirmContent]="isArabic() ? 'تأكيد' : 'Confirm'"
      [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'"
      (onCancel)="showCheckoutDialog.set(false)"
      (onSubmit)="onConfirmCheckout()" />
  }

  @if (showDeleteDialog()) {
    <app-confirmation-dialog
      [layout]="'start'"
      [title]="isArabic() ? 'حذف العربة' : 'Delete Cart'"
      [description]="
        isArabic()
          ? 'هل أنت متأكد أنك تريد حذف هذه العربة؟ لا يمكن التراجع عن هذا الإجراء.'
          : 'Are you sure you want to delete this cart? This action cannot be undone.'
      "
      [confirmContent]="isArabic() ? 'حذف' : 'Delete'"
      [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'"
      [error]="deleteError()"
      [isLoading]="deleteLoading()"
      (onCancel)="onCancelDelete()"
      (onSubmit)="onConfirmDelete()" />
  }
}
